import { create } from 'zustand';
import { startOfDay, subDays } from 'date-fns';

export const defaultSelectDateRange = {
  startDate: startOfDay(subDays(new Date(), 7)),
  endDate: startOfDay(subDays(new Date(), 1)),
  key: 'selection',
};

export const useFiltrosDashboardPichincha = create((set) => ({
    globalStatePeriod: defaultSelectDateRange,
    objetivo: null,
    changeGlobalPeriod: (statePeriod) =>
      set({ globalStatePeriod: statePeriod }),
    changeObjetivo: (objetivo) => set({ objetivo: objetivo }),
  }));
